import { render, staticRenderFns } from "./WhatsAppQRScan.vue?vue&type=template&id=22aaca43"
import script from "./WhatsAppQRScan.vue?vue&type=script&lang=js"
export * from "./WhatsAppQRScan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports